import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { DailyDollarRateService } from '../shared/services/dailydollarrate.service';
import { AdminService } from '../shared/services/admin.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TopbarComponent } from '../shared/components/topbar/topbar.component';
import { SidebarComponent } from '../shared/components/sidebar/sidebar.component';
import { BottombarComponent } from '../shared/components/bottombar/bottombar.component';
import { DollarRateModalComponent } from './dollar-rate-modal/dollar-rate-modal.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-dollar-rate',
    templateUrl: './dollar-rate.component.html',
    styleUrls: ['./dollar-rate.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        RouterModule,
        NgxPaginationModule,
        TopbarComponent,
        SidebarComponent,
        BottombarComponent,
        DollarRateModalComponent
    ]
})
export class DollarRateComponent implements OnInit {
  dailyRates;
  config: any;
  details;
  permission;
  page = 1;

  constructor(private dailyDollarRateService: DailyDollarRateService, private adminService: AdminService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.getDollarRates(this.page)
    this.getDetails()
  }

   getDollarRates(page) {
      // this.clicked = true;
      this.dailyDollarRateService.getAllDailyRates(page).subscribe(
        response => {
        this.dailyRates = response.data
         this.config = {
          itemsPerPage: 10,
          currentPage: this.page,
          totalItems: response.total
        };
        this.refresh();
        console.log('this is response', response)
          //            
        },
    );
    }

    refresh() {
      try {
        this.cdr.detectChanges();
      } catch (e) { void e; }
    }

    pageChanged(event) {
      this.page = event
    this.config.currentPage = event;
    this.getDollarRates(this.page)
  }

  getDetails() {
    this.adminService.getDetails().subscribe(
      data => {
        this.permission = data[0].permission;
        this.refresh();
        console.log('this is hfhf', this.permission)
      });
  }
}
